// Parent modules cover ALL their submodule routes.
// Submodule entries cover only their specific route(s).
const SIDEBAR_ROUTE_MAP = {
  // ── Dashboard ──
  Dashboard: ['/dashboard'],

  // ── Products ──
  Products: [
    '/products',
    '/products/new',
    '/products/update-price',
    '/products/variations',
    '/products/bulk-import',
    '/products/bulk-stock-import',
    '/products/price-groups',
    '/products/price-list',
    '/products/units',
    '/products/categories',
    '/products/brands',
    '/products/warranties',
    '/products/recipes',
  ],
  'All Products': ['/products'],
  'Categories': ['/products/categories'],
  'Brands': ['/products/brands'],
  'UOMs': ['/products/units'],
  'Price Lists': ['/products/price-groups', '/products/price-list'],
  'Warranties': ['/products/warranties'],
  'Recipes (BOM)': ['/products/recipes'],

  // ── Sales ──
  Sales: [
    '/sales',
    '/sales/pos',
    '/sales/orders',
    '/sales/history',
    '/sales/invoice/new',
    '/sales/pos-opening-entries',
    '/sales/invoice/:id',
    '/sales/pos-opening-entries/:name',
    '/sales/pos-invoice/:id',
    '/sales/invoice/:id/edit',
  ],
  'Point of Sale': ['/sales/pos'],
  'All Orders': ['/sales/orders'],
  'Sales History': ['/sales/history'],
  'POS Opening Entries': ['/sales/pos-opening-entries'],

  // ── Stores ──
  Stores: [
    '/warehouses',
    '/warehouses/:id',
    '/warehouses/:id/staff',
  ],
  'All Stores': ['/warehouses'],

  // ── Inventory ──
  Inventory: [
    '/inventory',
    '/inventory/stock-summary',
    '/inventory/low-stock',
    '/inventory/stock-ledger',
    '/inventory/item-details',
    '/inventory/stock-entries',
    '/inventory/stock-entries/:stockEntryName',
    '/inventory/material-receipts',
    '/inventory/material-issues',
    '/inventory/material-transfers',
    '/inventory/stock-entry',
    '/inventory/material-receipt',
    '/inventory/material-issue',
    '/inventory/material-transfer',
    '/inventory/stock-reconciliation',
    '/inventory/multi-level-reconciliation',
    '/inventory/multi-level-reconciliation/new',
    '/inventory/multi-level-reconciliation/:id',
    '/inventory/multi-level-reconciliation/:id/stock-take',
    '/inventory/stock-adjustments',
    '/inventory/counter-check',
    '/inventory/stock-snapshot',
  ],
  'Stock List': ['/inventory/stock-summary'],
  'Low Stock': ['/inventory/low-stock'],
  'Stock Ledger': ['/inventory/stock-ledger'],
  'Counter Stock Check': ['/inventory/counter-check'],
  'Stock Snapshot': ['/inventory/stock-snapshot'],
  'Entries': ['/inventory/stock-entries'],
  'Material Receipts': ['/inventory/material-receipts'],
  'Material Issues': ['/inventory/material-issues'],
  'Stock Adjustments': ['/inventory/stock-adjustments'],

  // ── Customers ──
  Customers: [
    '/customers',
    '/customers/credit',
    '/customers/report',
  ],
  'All Customers': ['/customers'],
  'Customer Credit': ['/customers/credit'],
  'Customer Report': ['/customers/report'],

  // ── Suppliers ──
  Suppliers: [
    '/suppliers',
    '/suppliers/groups',
    '/suppliers/:id',
    '/suppliers/report',
  ],
  'All Suppliers': ['/suppliers'],
  'Supplier Groups': ['/suppliers/groups'],
  'Supplier Report': ['/suppliers/report'],

  // ── Purchases ──
  Purchases: [
    '/purchases',
    '/purchases/new',
    '/purchases/create-order',
    '/purchases/submit-order',
    '/purchases/grns',
    '/purchases/grns/:id',
    '/purchases/returns',
    '/purchases/returns/:id',
    '/purchases/receipts',
    '/purchases/receipts/new',
    '/purchases/:id',
    '/purchases/receipts/:id',
    '/purchases/invoices',
    '/purchases/invoices/:invoiceNo',
    '/purchases/expenses',
  ],
  'All Purchases': ['/purchases'],
  'Purchase Invoices': ['/purchases/invoices'],
  'GRN List': ['/purchases/grns'],
  'Purchase Returns': ['/purchases/returns'],
  Expenses: ['/purchases/expenses'],

  // ── Stock Transfers ──
  'Stock Transfers': [
    '/stock-transfers',
    '/stock-transfers/list',
    '/stock-transfers/create-request',
    '/stock-transfers/:id',
    '/stock-transfers/:id/approve',
    '/stock-transfers/:id/dispatch',
    '/stock-transfers/:id/receive',
  ],
  'All Transfers': ['/stock-transfers/list'],

  // ── Roles ──
  Roles: [
    '/roles',
    '/roles/new',
    '/roles/:roleName',
    '/roles/:roleName/edit',
    '/roles/:roleName/permissions',
  ],

  // ── Settings ──
  Settings: [
    '/settings',
    '/settings/business',
    '/settings/pos-profile',
    '/settings/bank-accounts',
    '/settings/account-provisioning',
    '/settings/payment-methods',
    '/settings/inventory-discounts',
    '/settings/inventory-discounts/new',
    '/settings/inventory-discounts/:id/edit',
    '/settings/loyalty-programs',
    '/settings/module-visibility',
    '/settings/till-numbers',
    '/settings/database-backup',
  ],
  'Business Settings': ['/settings/business'],
  'POS Profile': ['/settings/pos-profile'],
  'Bank Accounts': ['/settings/bank-accounts'],
  'Account Provisioning': ['/settings/account-provisioning'],
  'Payment Methods': ['/settings/payment-methods'],
  'Inventory Discounts': ['/settings/inventory-discounts'],
  'Loyalty Programs': ['/settings/loyalty-programs'],
  'Module Visibility': ['/settings/module-visibility'],
  'Till Numbers': ['/settings/till-numbers'],

  // ── Cashier ──
  Cashier: [
    '/cashier',
    '/cashier/payment-method-report',
    '/cashier/mpesa-notifications',
    '/cashier/submitted-payments',
    '/cashier/total-sales-per-person',
    '/cashier/total-sales-per-warehouse',
    '/cashier/item-sales-report',
    '/cashier/sales-detail-report',
  ],
  'Payment Method Report': ['/cashier/payment-method-report'],
  'Mpesa Notifications': ['/cashier/mpesa-notifications'],
  'Submitted Payments': ['/cashier/submitted-payments'],
  'Total Sales Per Person': ['/cashier/total-sales-per-person'],
  'Total Sales Per Warehouse': ['/cashier/total-sales-per-warehouse'],
  'Item Sales Report': ['/cashier/item-sales-report'],
  'Sales Detail Report': ['/cashier/sales-detail-report'],

  // ── Reports ──
  Reports: [
    '/reports',
    '/staff-performance',
    '/reports/accounts',
    '/reports/accounts/z-report',
    '/reports/accounts/profit-and-loss',
    '/reports/accounts/customer-statement',
    '/reports/accounts/customer-statement-detail',
    '/reports/sales-analytics',
    '/reports/sales-analytics/report',
    '/reports/sales-analytics/table',
    '/reports/sales-analytics/product-analytics',
    '/reports/sales-performance',
    '/reports/waiter-revenue',
    '/reports/inventory-summary',
    '/reports/inventory-valuation',
    '/reports/inventory-valuation/value-by-category',
    '/reports/inventory-valuation/aggregated-value',
    '/reports/inventory-valuation/cost-method-comparison',
    '/reports/inventory-valuation/value-trends',
    '/reports/aging-stock',
    '/reports/aging-stock/stock-aging',
    '/reports/aging-stock/obsolescence-risk',
    '/reports/aging-stock/aging-recommendations',
    '/reports/performance-metrics',
    '/reports/performance-metrics/accuracy',
    '/reports/performance-metrics/variance',
    '/reports/performance-metrics/adjustment-trends',
    '/reports/performance-metrics/transfer-efficiency',
    '/reports/inventory/stock-entries',
    '/reports/inventory/stock-entries/:stockEntryName',
    '/reports/inventory/material-receipts',
    '/reports/inventory/material-issues',
    '/reports/inventory/material-transfers',
    '/reports/inventory/stock-entry',
    '/reports/inventory/stock-reconciliation',
    '/reports/inventory/multi-level-reconciliation',
    '/reports/inventory/multi-level-reconciliation/new',
    '/reports/inventory/multi-level-reconciliation/:id',
    '/reports/inventory/multi-level-reconciliation/:id/stock-take',
    '/reports/inventory/material-receipt',
    '/reports/inventory/material-issue',
    '/reports/inventory/material-transfer',
  ],
  'Reports Overview': ['/reports'],
  'Accounts Reports': ['/reports/accounts'],
  'Sales Analytics (Charts)': ['/reports/sales-analytics/report'],
  'Sales Analytics (Table)': ['/reports/sales-analytics/table'],
  'Product Sales Analytics': ['/reports/sales-analytics/product-analytics'],
  'Sales Performance': ['/reports/sales-performance'],
  'Waiter Revenue': ['/reports/waiter-revenue'],
  'Inventory Summary': ['/reports/inventory-summary'],
  'Inventory Valuation': ['/reports/inventory-valuation'],
  'Aging Stock': ['/reports/aging-stock'],
  'Performance Metrics': ['/reports/performance-metrics'],

  // ── Users ──
  Users: ['/staff'],

  // ── Attendance ──
  Attendance: ['/attendance'],

  // ── Shift Management ──
  'Shift Management': ['/shift-management'],

  // ── Service Tickets ──
  'Service Tickets': [
    '/service-tickets',
    '/service-tickets/new',
    '/service-tickets/:id',
  ],

  // ── Marketing ──
  Marketing: ['/marketing'],

  // ── CRM ──
  CRM: [
    '/crm',
    '/crm/promotions',
    '/crm/broadcasts',
    '/crm/customers/:id',
  ],
  'Customer 360': ['/crm'],
  'Promotions': ['/crm/promotions'],
  'Broadcast History': ['/crm/broadcasts'],
  // ── Production ──
  Production: [
    '/production',
    '/kds',
    '/production/kitchen-foods',
    '/production/factors',
    '/production/monitor',
    '/production/uom',
    '/production/item-sales',
    '/production/staff-sales',
  ],
  'Kitchen Foods': ['/production/kitchen-foods'],
  'Factors of Production': ['/production/factors'],
  'Production Monitor': ['/production/monitor'],
  'Units of Measure': ['/production/uom'],
  'Item Sales': ['/production/item-sales'],
  'Sales by Person': ['/production/staff-sales'],
};

// Maps submodule → parent for hierarchical permission checks
export const SUBMODULE_PARENTS = {
  // Products
  'All Products': 'Products',
  'Categories': 'Products',
  'Brands': 'Products',
  'UOMs': 'Products',
  'Price Lists': 'Products',
  'Warranties': 'Products',
  'Recipes (BOM)': 'Products',

  // Sales
  'Point of Sale': 'Sales',
  'All Orders': 'Sales',
  'Sales History': 'Sales',
  'POS Opening Entries': 'Sales',

  // Stores
  'All Stores': 'Stores',

  // Inventory
  'Stock List': 'Inventory',
  'Low Stock': 'Inventory',
  'Stock Ledger': 'Inventory',
  'Counter Stock Check': 'Inventory',
  'Stock Snapshot': 'Inventory',
  'Entries': 'Inventory',
  'Material Receipts': 'Inventory',
  'Material Issues': 'Inventory',
  'Stock Adjustments': 'Inventory',

  // Customers
  'All Customers': 'Customers',
  'Customer Credit': 'Customers',
  'Customer Report': 'Customers',

  // Suppliers
  'All Suppliers': 'Suppliers',
  'Supplier Groups': 'Suppliers',
  'Supplier Report': 'Suppliers',

  // Purchases
  'All Purchases': 'Purchases',
  'Purchase Invoices': 'Purchases',
  'GRN List': 'Purchases',
  'Purchase Returns': 'Purchases',

  // Stock Transfers
  'All Transfers': 'Stock Transfers',

  // Settings
  'POS Profile': 'Settings',
  'Bank Accounts': 'Settings',
  'Account Provisioning': 'Settings',
  'Payment Methods': 'Settings',
  'Inventory Discounts': 'Settings',
  'Loyalty Programs': 'Settings',
  'Module Visibility': 'Settings',
  'Till Numbers': 'Settings',

  // Production
  'Kitchen Foods': 'Production',
  'Factors of Production': 'Production',
  'Production Monitor': 'Production',
  'Units of Measure': 'Production',
  'Item Sales': 'Production',
  'Sales by Person': 'Production',

  // CRM
  'Customer 360': 'CRM',
  'Promotions': 'CRM',
  'Broadcast History': 'CRM',

  // Cashier
  'Payment Method Report': 'Cashier',
  'Mpesa Notifications': 'Cashier',
  'Submitted Payments': 'Cashier',
  'Submitted vs Actual': 'Cashier',
  'Total Sales Per Person': 'Cashier',
  'Item Sales Report': 'Cashier',

  // Shift Management
  'Shift Management': 'Shift Management',

  // Reports
  'Reports Overview': 'Reports',
  'Accounts Reports': 'Reports',
  'Sales Analytics (Charts)': 'Reports',
  'Sales Analytics (Table)': 'Reports',
  'Product Sales Analytics': 'Reports',
  'Sales Performance': 'Reports',
  'Inventory Summary': 'Reports',
  'Inventory Valuation': 'Reports',
  'Inventory Movement': 'Reports',
  'Aging Stock': 'Reports',
  'Performance Metrics': 'Reports',
  'Staff Performance': 'Reports',

};

export const getSidebarItemForRoute = (routePath) => {
  if (!routePath) return null;
  const normalizedPath = routePath.replace(/\/$/, '');
  for (const [itemName, routes] of Object.entries(SIDEBAR_ROUTE_MAP)) {
    for (const route of routes) {
      if (route === normalizedPath) {
        return {
          item: itemName,
          parent: SUBMODULE_PARENTS[itemName] || null,
        };
      }
      if (route.includes(':')) {
        const basePath = route.split(':')[0].replace(/\/$/, '');
        if (normalizedPath.startsWith(basePath + '/') || normalizedPath === basePath) {
          return {
            item: itemName,
            parent: SUBMODULE_PARENTS[itemName] || null,
          };
        }
      }
    }
  }
  return null;
};

export const getSidebarModules = () => SIDEBAR_ROUTE_MAP;

export default SIDEBAR_ROUTE_MAP;
